var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSmartphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_smartphone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_smartphone",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_iPhone_3609717",
    transform: "translate(24.000000, 18.000000)",
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "#000000",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.96901893,0 C0.957200323,0 0.143111384,0.780857217 0.143111384,1.75128939 L0.143111384,3.10098999 L0.0970527846,3.10098999 C0.0434080264,3.10098999 0,3.14266784 0,3.19402443 L0,3.97340021 C0,4.02485556 0.0434080264,4.06643465 0.0970527846,4.06643465 L0.143111384,4.06643465 L0.143111384,4.7503563 L0.0970527846,4.7503563 C0.0434080264,4.7503563 0,4.79203415 0,4.8434895 L0,6.36278537 C0,6.41424072 0.0434080264,6.45581981 0.0970527846,6.45581981 L0.143111384,6.45581981 L0.143111384,6.83288582 L0.0970527846,6.83288582 C0.0434080264,6.83288582 0,6.87446491 0,6.92592026 L0,8.44521613 C0,8.49667148 0.0434080264,8.53825057 0.0970527846,8.53825057 L0.143111384,8.53825057 L0.143111384,21.2487896 C0.143111384,22.2192119 0.957200323,23 1.96901893,23 L10.1000653,23 C11.111884,23 11.9267952,22.2192119 11.9267952,21.2487896 L11.9267952,7.99257691 C11.9673982,7.98151549 12,7.95149164 12,7.90892493 L12,5.44774918 C12,5.40518246 11.9673467,5.37525737 11.9267952,5.36409719 L11.9267952,1.75122026 C11.9267952,0.780788083 11.111884,0 10.1000653,0 L1.96901893,0 Z M1.83659953,0.516765823 L3.03824438,0.516765823 C3.02677298,0.560122637 3.01850409,0.604763367 3.01850409,0.651655885 L3.01850409,0.829932391 C3.01850409,1.13231407 3.2723804,1.37580357 3.58766061,1.37580357 L8.4822446,1.37580357 C8.79752584,1.37580357 9.05140215,1.13231407 9.05140215,0.829932391 L9.05140215,0.651655885 C9.05140215,0.604842377 9.04316416,0.560102885 9.03166186,0.516765823 L10.2333055,0.516765823 C10.8989968,0.516765823 11.4349501,1.03079592 11.4349501,1.66925711 L11.4349501,21.3310194 C11.4349501,21.9694806 10.8989968,22.4835107 10.2333055,22.4835107 L1.83659973,22.4835107 C1.17090881,22.4835107 0.634955195,21.9694806 0.634955195,21.3310194 L0.634955195,1.66925711 C0.634955195,1.03079592 1.17090881,0.516765823 1.83659953,0.516765823 L1.83659953,0.516765823 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmartphone);
export default __webpack_public_path__ + "static/media/icon_smartphone.7f5ae7ea89fa80eff46db4110f379dd8.svg";
export { ForwardRef as ReactComponent };